// Mock data para cursos y materias
let mockCoursesData = [
  {
    id: 1,
    name: '7° Básico A',
    level: '7° Básico',
    section: 'A',
    year: 2024,
    students: 32,
    headTeacher: 'María José Rodríguez',
    headTeacherId: 3,
    status: 'activo',
    subjects: [
      { id: 1, name: 'Matemáticas', teacherId: 3, teacherName: 'María José Rodríguez', hours: 6 },
      { id: 2, name: 'Lenguaje', teacherId: 3, teacherName: 'María José Rodríguez', hours: 6 },
      { id: 3, name: 'Ciencias Naturales', teacherId: 3, teacherName: 'María José Rodríguez', hours: 4 },
      { id: 4, name: 'Historia', teacherId: 3, teacherName: 'María José Rodríguez', hours: 4 },
      { id: 5, name: 'Inglés', teacherId: 3, teacherName: 'María José Rodríguez', hours: 3 }
    ],
    createdAt: '2024-03-01'
  },
  {
    id: 2,
    name: '8° Básico A',
    level: '8° Básico',
    section: 'A',
    year: 2024,
    students: 28,
    headTeacher: 'Ana María González',
    headTeacherId: 2,
    status: 'activo',
    subjects: [
      { id: 6, name: 'Matemáticas', teacherId: 2, teacherName: 'Ana María González', hours: 6 },
      { id: 7, name: 'Lenguaje', teacherId: 2, teacherName: 'Ana María González', hours: 6 },
      { id: 8, name: 'Ciencias Naturales', teacherId: 2, teacherName: 'Ana María González', hours: 4 },
      { id: 9, name: 'Historia', teacherId: 2, teacherName: 'Ana María González', hours: 4 },
      { id: 10, name: 'Inglés', teacherId: 2, teacherName: 'Ana María González', hours: 3 }
    ],
    createdAt: '2024-03-01'
  },
  {
    id: 3,
    name: '1° Medio A',
    level: '1° Medio',
    section: 'A',
    year: 2024,
    students: 35,
    headTeacher: 'Juan Carlos Pérez',
    headTeacherId: 1,
    status: 'activo',
    subjects: [
      { id: 11, name: 'Matemáticas', teacherId: 1, teacherName: 'Juan Carlos Pérez', hours: 7 },
      { id: 12, name: 'Lenguaje', teacherId: 1, teacherName: 'Juan Carlos Pérez', hours: 6 },
      { id: 13, name: 'Física', teacherId: 1, teacherName: 'Juan Carlos Pérez', hours: 4 },
      { id: 14, name: 'Química', teacherId: 1, teacherName: 'Juan Carlos Pérez', hours: 4 },
      { id: 15, name: 'Inglés', teacherId: 1, teacherName: 'Juan Carlos Pérez', hours: 4 }
    ],
    createdAt: '2024-03-01'
  }
];

let mockSubjectsData = [
  { id: 1, name: 'Matemáticas', description: 'Matemática y cálculo' },
  { id: 2, name: 'Lenguaje', description: 'Lenguaje y comunicación' },
  { id: 3, name: 'Ciencias Naturales', description: 'Biología, química y física básica' },
  { id: 4, name: 'Historia', description: 'Historia, geografía y ciencias sociales' },
  { id: 5, name: 'Inglés', description: 'Idioma inglés' },
  { id: 6, name: 'Física', description: 'Física avanzada' },
  { id: 7, name: 'Química', description: 'Química avanzada' },
  { id: 8, name: 'Biología', description: 'Biología avanzada' },
  { id: 9, name: 'Educación Física', description: 'Educación física y deportes' },
  { id: 10, name: 'Artes', description: 'Artes visuales y música' }
];

// Simular delay de red
const delay = (ms) => new Promise(resolve => setTimeout(resolve, ms));

class CourseService {
  constructor() {
    this.nextCourseId = 4;
    this.nextSubjectId = 16;
  }

  // ============ CURSOS ============

  // Obtener todos los cursos
  async getCourses(filters = {}) {
    await delay(300);

    let courses = [...mockCoursesData];

    // Aplicar filtros
    if (filters.level && filters.level !== 'todos') {
      courses = courses.filter(c => c.level === filters.level);
    }

    if (filters.year && filters.year !== 'todos') {
      courses = courses.filter(c => c.year === parseInt(filters.year));
    }

    if (filters.status && filters.status !== 'todos') {
      courses = courses.filter(c => c.status === filters.status);
    }

    if (filters.search) {
      const searchLower = filters.search.toLowerCase();
      courses = courses.filter(c =>
        c.name.toLowerCase().includes(searchLower) ||
        c.headTeacher.toLowerCase().includes(searchLower)
      );
    }

    return {
      success: true,
      data: courses,
      total: courses.length
    };
  }

  // Obtener un curso por ID
  async getCourseById(id) {
    await delay(300);

    const course = mockCoursesData.find(c => c.id === parseInt(id));

    if (!course) {
      return {
        success: false,
        message: 'Curso no encontrado'
      };
    }

    return {
      success: true,
      data: course
    };
  }

  // Crear nuevo curso
  async createCourse(courseData) {
    await delay(500);

    try {
      // Validar que no exista un curso con el mismo nombre
      const exists = mockCoursesData.some(c =>
        c.name === courseData.name && c.year === courseData.year
      );

      if (exists) {
        return {
          success: false,
          message: 'Ya existe un curso con ese nombre para el año seleccionado'
        };
      }

      // Crear nuevo curso
      const newCourse = {
        id: this.nextCourseId++,
        ...courseData,
        students: courseData.students || 0,
        subjects: courseData.subjects || [],
        status: courseData.status || 'activo',
        createdAt: new Date().toISOString().split('T')[0]
      };

      mockCoursesData.push(newCourse);

      return {
        success: true,
        data: newCourse,
        message: 'Curso creado exitosamente'
      };
    } catch (error) {
      return {
        success: false,
        message: 'Error al crear curso'
      };
    }
  }

  // Actualizar curso
  async updateCourse(id, courseData) {
    await delay(500);

    try {
      const courseIndex = mockCoursesData.findIndex(c => c.id === parseInt(id));

      if (courseIndex === -1) {
        return {
          success: false,
          message: 'Curso no encontrado'
        };
      }

      // Validar nombre único (excepto el curso actual)
      if (courseData.name) {
        const exists = mockCoursesData.some(c =>
          c.name === courseData.name &&
          c.year === (courseData.year || mockCoursesData[courseIndex].year) &&
          c.id !== parseInt(id)
        );

        if (exists) {
          return {
            success: false,
            message: 'Ya existe un curso con ese nombre para el año seleccionado'
          };
        }
      }

      // Actualizar curso
      mockCoursesData[courseIndex] = {
        ...mockCoursesData[courseIndex],
        ...courseData,
        id: parseInt(id) // Asegurar que el ID no cambie
      };

      return {
        success: true,
        data: mockCoursesData[courseIndex],
        message: 'Curso actualizado exitosamente'
      };
    } catch (error) {
      return {
        success: false,
        message: 'Error al actualizar curso'
      };
    }
  }

  // Eliminar curso
  async deleteCourse(id) {
    await delay(500);

    const courseIndex = mockCoursesData.findIndex(c => c.id === parseInt(id));

    if (courseIndex === -1) {
      return {
        success: false,
        message: 'Curso no encontrado'
      };
    }

    mockCoursesData.splice(courseIndex, 1);

    return {
      success: true,
      message: 'Curso eliminado exitosamente'
    };
  }

  // Cambiar estado del curso
  async toggleCourseStatus(id) {
    await delay(300);

    const courseIndex = mockCoursesData.findIndex(c => c.id === parseInt(id));

    if (courseIndex === -1) {
      return {
        success: false,
        message: 'Curso no encontrado'
      };
    }

    const newStatus = mockCoursesData[courseIndex].status === 'activo' ? 'inactivo' : 'activo';
    mockCoursesData[courseIndex].status = newStatus;

    return {
      success: true,
      data: { status: newStatus },
      message: `Curso ${newStatus === 'activo' ? 'activado' : 'desactivado'} exitosamente`
    };
  }

  // Agregar materia al curso
  async addSubjectToCourse(courseId, subjectData) {
    await delay(400);

    const courseIndex = mockCoursesData.findIndex(c => c.id === parseInt(courseId));

    if (courseIndex === -1) {
      return {
        success: false,
        message: 'Curso no encontrado'
      };
    }

    // Verificar que la materia no exista ya en el curso
    const subjectExists = mockCoursesData[courseIndex].subjects.some(
      s => s.name === subjectData.name
    );

    if (subjectExists) {
      return {
        success: false,
        message: 'Esta materia ya está asignada al curso'
      };
    }

    const newSubject = {
      id: this.nextSubjectId++,
      ...subjectData
    };

    mockCoursesData[courseIndex].subjects.push(newSubject);

    return {
      success: true,
      data: newSubject,
      message: 'Materia agregada exitosamente'
    };
  }

  // Actualizar materia del curso
  async updateCourseSubject(courseId, subjectId, subjectData) {
    await delay(400);

    const courseIndex = mockCoursesData.findIndex(c => c.id === parseInt(courseId));

    if (courseIndex === -1) {
      return {
        success: false,
        message: 'Curso no encontrado'
      };
    }

    const subjectIndex = mockCoursesData[courseIndex].subjects.findIndex(
      s => s.id === parseInt(subjectId)
    );

    if (subjectIndex === -1) {
      return {
        success: false,
        message: 'Materia no encontrada en el curso'
      };
    }

    mockCoursesData[courseIndex].subjects[subjectIndex] = {
      ...mockCoursesData[courseIndex].subjects[subjectIndex],
      ...subjectData,
      id: parseInt(subjectId)
    };

    return {
      success: true,
      data: mockCoursesData[courseIndex].subjects[subjectIndex],
      message: 'Materia actualizada exitosamente'
    };
  }

  // Eliminar materia del curso
  async removeSubjectFromCourse(courseId, subjectId) {
    await delay(400);

    const courseIndex = mockCoursesData.findIndex(c => c.id === parseInt(courseId));

    if (courseIndex === -1) {
      return {
        success: false,
        message: 'Curso no encontrado'
      };
    }

    const subjectIndex = mockCoursesData[courseIndex].subjects.findIndex(
      s => s.id === parseInt(subjectId)
    );

    if (subjectIndex === -1) {
      return {
        success: false,
        message: 'Materia no encontrada en el curso'
      };
    }

    mockCoursesData[courseIndex].subjects.splice(subjectIndex, 1);

    return {
      success: true,
      message: 'Materia eliminada del curso exitosamente'
    };
  }

  // ============ MATERIAS ============

  // Obtener todas las materias disponibles
  async getAvailableSubjects() {
    await delay(200);

    return {
      success: true,
      data: mockSubjectsData
    };
  }

  // Obtener niveles disponibles
  getLevels() {
    return [
      '1° Básico', '2° Básico', '3° Básico', '4° Básico',
      '5° Básico', '6° Básico', '7° Básico', '8° Básico',
      '1° Medio', '2° Medio', '3° Medio', '4° Medio'
    ];
  }

  // Obtener secciones disponibles
  getSections() {
    return ['A', 'B', 'C', 'D'];
  }

  // Obtener años disponibles
  getYears() {
    const currentYear = new Date().getFullYear();
    return [currentYear - 1, currentYear, currentYear + 1];
  }

  // Obtener profesores (esto debería venir del userService)
  async getTeachers() {
    await delay(200);

    // Mock de profesores (en producción esto vendría del userService)
    return {
      success: true,
      data: [
        { id: 1, name: 'Juan Carlos Pérez' },
        { id: 2, name: 'Ana María González' },
        { id: 3, name: 'María José Rodríguez' }
      ]
    };
  }
}

export const courseService = new CourseService();
